import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import {onMounted} from "vue";
import {useContentsStore} from "@/store/contents-store";
import {refresh} from "@/services/auth-service";
import {storeToRefs} from "pinia";
import {useFilesStore} from "@/store/file-store";
import {useContactUsStore} from "@/store/contact-us-store";
import {useGalleryStore} from "@/store/gallery-store";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const contentStore = useContentsStore();
const fileStore = useFilesStore();
const contactUsStore = useContactUsStore();
const galleryStore = useGalleryStore();

onMounted(async () => {
  try {
    await refresh();

    contactUsStore.fetchAll();

    const store = useContentsStore();
    const { logged } = storeToRefs(store)
    logged.value = true;
  } finally {
    contentStore.fetchAll();
    fileStore.fetchAll();
    galleryStore.fetchAll();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header),
    _createVNode(_component_router_view),
    _createVNode(Footer)
  ], 64))
}
}

})